import React from 'react'
import ReactDOM from 'react-dom'
import StaticTextComponent from './StaticTextComponent'
import {getStatusText} from '../../helpers/getStatusText'

class CustomStatusComponent extends React.Component {

  render() {
    return <StaticTextComponent value={getStatusText(this.props)}/>
  }
}

export default CustomStatusComponent;



// WEBPACK FOOTER //
// ./src/components/common/CustomStatusComponent.js